import { render, staticRenderFns } from "./ExtraFieldTimeOptions.vue?vue&type=template&id=f3ea0242"
import script from "./ExtraFieldTimeOptions.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldTimeOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ea0242')) {
      api.createRecord('f3ea0242', component.options)
    } else {
      api.reload('f3ea0242', component.options)
    }
    module.hot.accept("./ExtraFieldTimeOptions.vue?vue&type=template&id=f3ea0242", function () {
      api.rerender('f3ea0242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldTimeOptions.vue"
export default component.exports